import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemContentBase } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-news-feed-item-content-task-reminder',
    template: `
        <div class="NewsFeedContent">
            <div class="NewsFeedContentHeader">
                <span>{{ getTaskReminderTextFirst() }}</span>
                <a
                    class="NewsFeedItem-FormReadMore BrandedColor"
                    [fiStateSref]="FiStateNames.Task.Details"
                    [fiStateSrefParams]="{ id: newsItem.Content.TaskId }"
                >
                    {{ newsItem.Content.Name }}
                </a>
                <span>{{ getTaskReminderTextLast() }}</span>
            </div>
        </div>
    `,
    styleUrls: ['./news-feed-item-content-task-reminder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemContentTaskReminderComponent extends NewsFeedItemContentBase {
    getTaskReminderTextFirst(): string {
        return this.injector
            .get(AppTextService)
            .get('task.reminder_feed_text', {
                '{0}': this.injector.get(FiUserDataService).getUserProfile().FullName.split(' ')[0],
            })
            .split('{1}')[0];
    }

    getTaskReminderTextLast(): string {
        return this.injector.get(AppTextService).get('task.reminder_feed_text').split('{1}')[1];
    }
}
